import React, { useState, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import "../css/Aboutus.css";
import data from "../../ApiUrl/meta_api";
import { useNavigate } from "react-router-dom";
import { Award, BookOpen, Briefcase, Target, CheckCircle } from "lucide-react";
import Footer from "../../Footer/Footer";

const AboutUs = () => {
  const [meta, setMeta] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false,
      offset: 100,
      delay: 100,
    });

    const AboutMeta = data[0]?.about_page;
    if (AboutMeta) {
      setMeta(AboutMeta);
    }
  }, []);

  return (
    <HelmetProvider>
      <div className="about-page" style={{ overflowX: "hidden" }}>
        <Helmet>
          <title>{meta?.title || "About Us - Berlin Technovation"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Based in Salem, we've successfully trained over 2,000 learners since 2020, equipping them with the knowledge and confidence to thrive in today's fast-paced tech industry."
            }
          />
        </Helmet>

        {/* Hero Section */}
        <div style={{ width: "100%" }} data-aos="fade-down">
          <div
            className="position-relative"
            style={{
              backgroundImage: `url(${require("../../Img/images/BannerImage/AboutusBanner.png")})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              height: "350px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                zIndex: 1,
              }}
            ></div>

            <div
              className="position-absolute top-50 start-50 translate-middle text-center"
              style={{ zIndex: 2 }}
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <h1 className="fw-bold" style={{ color: "#008cff" }}>
                AboutUs
              </h1>
            </div>

            <div
              className="container h-100 d-flex align-items-end pb-4"
              style={{ zIndex: 2, position: "relative" }}
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <nav aria-label="breadcrumb">
                <ol
                  className="breadcrumb mb-0 px-3 py-2 rounded d-flex align-items-center"
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                  }}
                >
                  <li className="breadcrumb-item d-flex align-items-center">
                    <button
                      onClick={() => navigate("/")}
                      className="btn btn-link p-0 text-decoration-none"
                      style={{
                        color: "#0663ad",
                        fontWeight: "bold",
                        background: "none",
                        border: "none",
                      }}
                    >
                      Home
                    </button>
                  </li>
                  <li
                    className="breadcrumb-item active d-flex align-items-center"
                    aria-current="page"
                    style={{ color: "#000000" }}
                  >
                    About Us
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        {/* Who We Are Section */}
        <div className="container py-5" style={{ marginTop: "70px" }}>
          <div className="row align-items-center">
            <div
              className="col-lg-6 mb-4 mb-lg-0"
              data-aos="fade-left"
              data-aos-delay="100"
            >
              <div className="image-wrapper">
                <img
                  src={require("../../Img/images/Our Vision.jpg")}
                  alt="Who We Are"
                  className="img-fluid rounded"
                />
              </div>
            </div>

            <div
              className="col-lg-6"
              data-aos="fade-right"
              data-aos-delay="1000"
            >
              <div data-aos="zoom-in">
                <h2 className="fw-bold mb-3 ms-5">
                  <span style={{ color: "#000000" }}>Who</span>{" "}
                  <span style={{ color: "#0663ad" }}>We Are</span>
                </h2>
                <div
                  className="section-divider mb-4"
                  style={{ marginLeft: "100px", background: "#008cff" }}
                ></div>
              </div>

              <p className="" style={{ textAlign: "justify", color: "#000000" }}>
                We are a premier IT training institute committed to helping
                students and working professionals develop practical, job-ready
                skills in emerging technologies. Based in Salem, we've
                successfully trained over 2,000 learners since 2020, equipping
                them with the knowledge and confidence to thrive in today's
                fast-paced tech industry. Our curriculum is crafted by industry
                experts and is constantly updated to meet current market needs.
                We focus on real-world applications through hands-on projects,
                case studies, and interactive sessions. We specialize in a wide
                range of in-demand domains including Cybersecurity, Data
                Analytics, Oracle SQL, Power BI, Python, Software Testing, and
                Tableau.
              </p>
            </div>
          </div>
        </div>

        {/* Mission and Vision Section */}
        <section
          className="py-5 position-relative text-white"
          style={{
            backgroundImage: `url(${require("../../Img/images/ourvsionpart.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              width: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1,
            }}
          ></div>

          <div className="container position-relative" style={{ zIndex: 2 }}>
            <div className="row align-items-center mb-5">
              {/* Our Mission */}
              <div
                className="col-lg-6 mb-4 mb-lg-0"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <div className="content-card p-4" style={{  background: "#ffffff" }}>
                  {/* <h2 className="fw-bold mb-4 d-flex align-items-center gap-2">
                    <div className="icon-wrapper" style={{ background: "#0663ad" }}>
                      <Target size={32} style={{ color: "#ffffff" }} />
                    </div>
                    <span className="ms-4" style={{color:"#000000"}}>Our</span>{" "}
                    <span style={{color:"#008cff"}}>Mission</span>
                  </h2> */}
                  <h2 className="fw-bold mb-4 d-flex align-items-center gap-2">
                    <div className="icon-wrapper" style={{ background: "#008cff" }}>
                      <Target size={32} style={{ color: "#ffffff" }}  />
                    </div>
                    <span className="ms-0 ms-md-4 our-missionand-vission" style={{color:"#000000"}}>Our</span>{" "}
                    <span style={{color:"#0663ad"}} >Mission</span>
                  </h2>
                  <p
                    className="lh-lg mb-4"
                    style={{ textAlign: "justify", color: "#000000" }}
                  >
                    We deliver practical, hands-on training in Data Analytics
                    and cutting-edge technologies. Our programs are designed to
                    meet real-world industry standards, emphasizing live
                    projects, resume building, interview readiness, and
                    certification support to empower career growth. We focus on
                    bridging the gap between academic knowledge and real-time
                    industry application. Through personalized mentorship,
                    collaborative learning, and continuous upskilling.
                  </p>
                </div>
              </div>

              {/* Our Vision */}
              <div
                className="col-lg-6 mb-4 mb-lg-0"
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                <div className="content-card p-4" style={{background: "#ffffff" }}>
                  <h2 className="fw-bold mb-4 d-flex align-items-center gap-2">
                    <div className="icon-wrapper" style={{ background: "#008cff" }}>
                      <Award size={32} style={{ color: "#ffffff" }} />
                    </div>
                    <span className="ms-0 ms-md-4" style={{color:"#000000"}}>Our</span>{" "}
                    <span style={{color:"#0663ad"}}>Vision</span>
                  </h2>
                  <p
                    className="lh-lg mb-4"
                    style={{ textAlign: "justify", color: "#000000" }}
                  >
                    To be the most trusted and result-driven IT training
                    institute, known for transforming learners into
                    top-performing professionals who are industry-ready from day
                    one. We envision a future where every learner, regardless of
                    background, has access to high-quality, hands-on IT training
                    that aligns with current industry standards and future
                    trends. Our goal is to bridge the gap between academic
                    knowledge and real-world application.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Training Programs Section */}
        <section className="py-5" style={{ background: "#f8f9fa" }}>
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <h2 className="fw-bold mb-4">
                <span style={{ color: "#0663ad" }}>Our</span>{" "}
                <span style={{ color: "#000000" }}>Training Programs</span>
              </h2>
              <div className="section-divider mx-auto mb-4" style={{ background: "#008cff" }}></div>
              <p className="col-lg-8 mx-auto" style={{ color: "#000000" }}>
                Our training programs are tailored to match real-world industry
                standards, with a strong focus on live projects, resume
                building, interview preparation, and certification support.
              </p>
            </div>

            <div className="row g-4">
              {[
                {
                  icon: BookOpen,
                  title: "Live Projects",
                  description:
                    "Hands-on training in Data Analytics, AI, ML, Cybersecurity, and Cloud technologies",
                  delay: 100,
                  color: "#0663ad"
                },
                {
                  icon: Target,
                  title: "Resume Building",
                  description:
                    "Programs tailored to match real-world industry requirements and current market demands",
                  delay: 200,
                  color: "#008cff"
                },
                {
                  icon: Briefcase,
                  title: "Interview Preparation",
                  description:
                    "Work on real projects with resume building and interview preparation support",
                  delay: 300,
                  color: "#0663ad"
                },
                {
                  icon: Award,
                  title: "Certification Support",
                  description:
                    "Get certified in cutting-edge technologies with our comprehensive guidance",
                  delay: 400,
                  color: "#008cff"
                },
              ].map((program, index) => (
                <div
                  key={index}
                  className="col-md-6 col-lg-3"
                  data-aos="fade-up"
                  data-aos-delay={program.delay}
                >
                  <div className="program-card h-100" style={{ background: "#ffffff" }}>
                    <div className="card-body text-center p-4">
                      <div className="icon-circle mb-4" style={{ background: program.color }}>
                        <program.icon className="text-white" size={28} />
                      </div>
                      <h5 className="card-title fw-bold mb-3" style={{ color: "#000000" }}>
                        {program.title}
                      </h5>
                      <p className="card-text small lh-lg" style={{ color: "#000000" }}>
                        {program.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Core Values Section */}
        <section className="py-5">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0" data-aos="fade-right">
                <h2 className="fw-bold mb-4">
                  <span style={{ color: "#0663ad" }}>Our</span>{" "}
                  <span style={{ color: "#000000" }}>Core Values</span>
                </h2>
                <div className="values-list">
                  {[
                    "Quality Education",
                    "Industry Alignment",
                    "Student-Centered Approach",
                    "Innovation in Learning",
                  ].map((value, index) => (
                    <div
                      key={index}
                      className="value-item"
                      style={{ background: "#ffffff" }}
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                    >
                      <div className="value-check" style={{ background: index % 2 === 0 ? "#0663ad" : "#008cff" }}>
                        <CheckCircle className="text-white" size={16} />
                      </div>
                      <span className="value-text" style={{ color: "#000000" }}>{value}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-lg-6" data-aos="fade-left">
                <div className="image-wrapper">
                  <img
                    src={require("../../Img/images/Our Core Values.jpg")}
                    alt="Core Values"
                    className="img-fluid rounded-4 shadow-lg hover-scale"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Infrastructure Section */}
        <section className="py-5" style={{ background: "#f8f9fa" }}>
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-lg-6 order-lg-2 mb-4 mb-lg-0"
                data-aos="fade-left"
              >
                <h2 className="fw-bold mb-4">
                  <span style={{ color: "#0663ad" }}>Our</span>{" "}
                  <span style={{ color: "#000000" }}>Infrastructure</span>
                </h2>
                <div className="infrastructure-list">
                  {[
                    "Smart classrooms",
                    "Cloud labs (AWS, Azure)",
                    "Recorded video library",
                    "Interview simulator pods",
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="infrastructure-item"
                      style={{ background: "#ffffff" }}
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                    >
                      <div className="infrastructure-check" style={{ background: index % 2 === 0 ? "#008cff" : "#0663ad" }}>
                        <CheckCircle className="text-white" size={16} />
                      </div>
                      <span className="infrastructure-text" style={{ color: "#000000" }}>{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-lg-6 order-lg-1" data-aos="fade-right">
                <div className="image-wrapper">
                  <img
                    src={require("../../Img/images/about-us-infra.jpeg")}
                    alt="Our Infrastructure"
                    className="img-fluid rounded-4 shadow-lg hover-scale"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default AboutUs;